// extracted by mini-css-extract-plugin
module.exports = {"main":"IndexPage_main__1yjom","section":"IndexPage_section__2ATJp","banner":"IndexPage_banner__1Vtol"};